<template lang="pug">
table-base.study-result-last-minute-check-table
  //- ヘッダー部
  table-row-base.study-result-last-minute-check-table__row-header.text-medium
    table-header-base.study-result-last-minute-check-table__row-header__cell.align-left
      slot(name='problemNumberHeader')
    table-header-base.study-result-last-minute-check-table__row-header__cell.align-center
      slot(name='questionNumberHeader')
    table-header-base.study-result-last-minute-check-table__row-header__cell.align-center
      slot(name='correctAnswerHeader')
    table-header-base.study-result-last-minute-check-table__row-header__cell.align-center
      slot(name='correctSymbolHeader')
    table-header-base.study-result-last-minute-check-table__row-header__cell.align-center
      slot(name='previousCorrectSymbolHeader')
    table-header-base.study-result-last-minute-check-table__row-header__cell.align-center
      slot(name='previousTwoCorrectSymbolHeader')
  template(v-for='detail in studyResultLastMinuteChecks')
    //- 一覧表示部
    table-row-base.study-result-last-minute-check-table__row.text-small.font-medium
      table-data-base.study-result-last-minute-check-table__row__cell
        .study-result-last-minute-check-table__row__cell__text-left 
          .study-result-last-minute-check-table__row__cell__text-left__label(v-if='detail.isNeedCheck') {{ annotationLabel }}
          .study-result-last-minute-check-table__row__cell__text-left__value {{ detail.problemNumberText }}
      table-data-base.study-result-last-minute-check-table__row__cell
        .study-result-last-minute-check-table__row__cell__text {{ detail.questionNumberText }}
      table-data-base.study-result-last-minute-check-table__row__cell
        .study-result-last-minute-check-table__row__cell__text(v-html='detail.correctAnswer')
      table-data-base.study-result-last-minute-check-table__row__cell
        .study-result-last-minute-check-table__row__cell__text {{ detail.correctSymbol }}
      table-data-base.study-result-last-minute-check-table__row__cell
        .study-result-last-minute-check-table__row__cell__text {{ detail.previousCorrectSymbol }}
      table-data-base.study-result-last-minute-check-table__row__cell
        .study-result-last-minute-check-table__row__cell__text {{ detail.previousTwoCorrectSymbol }}
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import TableBase from '@/components/atoms/TableBase.vue'
import TableRowBase from '@/components/atoms/TableRowBase.vue'
import TableHeaderBase from '@/components/atoms/TableHeaderBase.vue'
import TableDataBase from '@/components/atoms/TableDataBase.vue'
import { StudyResultLastMinuteCheckType } from '@/models/studyResultDetailModel'

/**
 * テスト結果直前チェック詳細テーブル
 */
@Component({
  components: {
    TableBase,
    TableRowBase,
    TableHeaderBase,
    TableDataBase,
  },
})
export default class StudyResultLastMinuteCheckTable extends Vue {
  // テスト結果直前チェック詳細表示情報
  @Prop()
  studyResultLastMinuteChecks!: StudyResultLastMinuteCheckType[]

  // 注釈のラベル記号
  @Prop()
  annotationLabel!: string
}
</script>

<style lang="stylus" scoped>
.study-result-last-minute-check-table
  width 100%
  table-layout fixed

  &__row-header,
  &__row
    border-bottom 1px solid var(--color-manager-list__border)

  &__row-header
    background var(--color-manager-list__background)

    &__cell
      padding 10px 20px

  &__row
    background var(--color-manager-list__background)
    height 55px

    &__cell
      padding 0 20px

      &__text
        display flex
        justify-content center

      &__text-left
        display flex
        align-items center

        &__label
          margin-right 5px
          color var(--color-manager-list-alert__text)

    &:hover
      background var(--color-manager-list__hover)
</style>
